const BYTE_SIZE_LIMIT = 3e6; // 3 MB

export const validateGpx = (
  file: File | null,
  sizeLimit = BYTE_SIZE_LIMIT,
): { valid: boolean; reason?: string } => {
  if (!file) return { valid: false, reason: "Upload cancelled" };
  if (!file.name.toLowerCase().endsWith(".gpx"))
    return { valid: false, reason: "File must have a .gpx extension" };
  if (file.size > sizeLimit) return { valid: false, reason: "File exceeds 3 MB limit" };

  return { valid: true };
};
